
import { Object3D } from 'three';
import { globalConfig, globalManager, globalTools } from './globalConfig';
import { VisionaryObject } from '@/visionaryControllers/visionaryScene';

export class CameraUtils {

    // 同步相机位置
    onPositionChange(value: { x: number, y: number, z: number }): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.scene.updateCameraPosition(value);
            if (sceneView.cameraController && typeof sceneView.cameraController.syncFromCamera === 'function') {
                sceneView.cameraController.syncFromCamera();
            }
        });
    }
    // 同步GizmoHelper的相机参数到其他场景
    onGizmoChange(sceneId: string, cameraParams: { position: { x: number, y: number, z: number }, quaternion: { x: number, y: number, z: number, w: number }, fov: number, near: number, far: number }): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            if (sceneView.scene.getId() != sceneId) {
                sceneView.cameraController.syncFromValue(cameraParams.position, cameraParams.quaternion);
            }
        });
        globalTools?.rightPanelTools?.onUpdateCamera(cameraParams);
    }

    // 控制器模式切换
    onCameraModeChange(value: string): void {
        globalConfig.mouseMovementMode = value as 'orbit' | 'fps';
    }

    // 拖拽速度 by helen 需对接
    onDragSpeedChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.setMouseControls('dragSpeed', value);
        });
    }

    // 滚轮缩放速度 by helen 需对接
    onScaleSpeedChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.setMouseControls('wheelSpeed', value);
        });
    }
    // 阻尼 by helen 需对接
    onDampingChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.setMouseControls('inertiaFactor', value);
            // console.log('场景设置 阻尼改变onDampingChange', value);
        });
    }

    // 网格可见性
    onGridVisibleChange(value: boolean): void {
        globalConfig.sceneParams.grid = value;
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.scene.setGridVisible(value);
        });
    }

    // 相机速度 by helen 需测试
    onSpeedChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.setMouseControls('moveSpeed', value);
            // console.log('场景设置 相机速度改变onSpeedChange', value);
        });
    }
    // 视野角
    onFOVChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.updateCameraFOV(value);
            // console.log('场景设置 视野角改变onFOVChange', value);
        });
    }
    // 近平面
    onNearPlaneChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.updateCameraNear(value);
            // console.log('场景设置 近平面改变onNearPlaneChange', value);
        });
    }
    // 远平面
    onFarPlaneChange(value: number): void {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.cameraController.updateCameraFar(value);
            // console.log('场景设置 远平面改变onFarPlaneChange', value);
        });
    }
}

// 创建并导出单例实例
const cameraUtils = new CameraUtils();
export { cameraUtils };